import { date, number, object, string } from '@/core/utils/validation';
import { t } from '@/core/localization';
import { getEnumValuesAsArray } from '@/core/utils/convert';
import { TrackableStatus } from '@/shared/models';
const documentGeneratedMessageSchema = object({
    shipmentId: number().integer().positive().required(),
    createDate: date().typeError(t('invalid.date.error.message')).defined(),
    quantity: number().min(0).required(),
    amount: number().min(0).required(),
    contractorName: string().required(),
    documentNum: number().min(0).required(),
    documentYear: number().min(0).required(),
    trackableStatus: number().oneOf(getEnumValuesAsArray(TrackableStatus)).required(),
    driverId: number().integer().positive().nullable().required(),
    driverName: string().nullable().required(),
    driverVehicleNumber: string().nullable().required(),
    placeCount: number().min(0).required(),
    totalWeight: number().min(0).required(),
}).noUnknown(true);
export { documentGeneratedMessageSchema };
